import * as React from 'react';
import * as S from './styles';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { IOverallProps } from './types';
import TopTextInput from '../TopTextInput';
import { ProviderRating } from '../../state/types';
import { getIsSelected } from '../../state/utils';
import { Context } from '../../context';
import EditIcon from 'common/icons/editIcon';
import EmptyMessage from '../EmptyMessage';
import { EmptyMessageContainer } from '../EmptyMessage/styles';

const LeaveReviews: React.FC<IOverallProps> = (props) => {

    const context = React.useContext(Context);

    const {
        providersRating,
        widgets
    } = useSelector((rootState: RootState) => {
        return {
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
            providersRating: rootState.reviews.providersRating,
            widgets: rootState.reviews.widgets,
        }
    }, shallowEqual);

    const handleEditProviders =  (event: any) => {
        var container = document.getElementById('container');
        if (container) {
            var rect = container.getBoundingClientRect();
            var x = event.clientX + container.scrollLeft - rect.left - 581;
            var y = event.clientY + container.scrollTop - rect.top -150;
            props.handleEditProviders({show: true, posX: x , posY: y, widget: 'leaveReview'})
        }
    }

    const titleColor = context.editingStatus.titleText?.id === "leaveReview" ? context.editingStatus.titleText.color : props.widgetsConfig.leaveReview.titleTextColor ?? "#000000";

    const hasProviders = props.widgetsConfig.leaveReview?.providers && props.widgetsConfig.leaveReview.providers.length > 0;

    const renderEditIcon = () => {
        if (props.selectedTab === "individual" ) {
            return (
                <S.EditIconContainer onClick={(e) => handleEditProviders(e)}>
                    <EditIcon />
                </S.EditIconContainer>
            );
        }
    }

    const renderImages = () => {
        let elements: any[]=[];
        const filterProviders: ProviderRating[]|undefined = providersRating?.providersRating.filter( (provider: ProviderRating) => getIsSelected(provider, props.selectedTab, widgets, 'leaveReview'));
        if (filterProviders) {
            const group = filterProviders.length===5 ? 3:2;
            for(var i = 0; i < filterProviders?.length; i += group) {
                elements.push(<S.ImgOutsideContainer>
                        {filterProviders[i] && 
                        <S.ImgContainer height={86} src= {filterProviders[i].iconUrl} onClick={()=>{}}/>}
                        {filterProviders[i+1] && <S.ImgContainer height={86} src= {filterProviders[i+1].iconUrl} onClick={()=>{}}/>}
                        {group ===3 && filterProviders[i+2] && <S.ImgContainer height={86} src= {filterProviders[i+2].iconUrl} onClick={()=>{}}/>}
                        </S.ImgOutsideContainer>)
            }
        }
        return elements;
    }

    return (
        <S.Root>
            <S.Title>
                <TopTextInput
                    {...props}
                    widgetType={"leaveReview"}
                    textTag={props.widgetsConfig.leaveReview.titleTag}
                    style={{height: "68px"}}                  
                    inputStyle={{                        
                        width: "411px",
                        height: "42px",
                        border: "solid 2px #e7e7ec",
                        borderRadius: "5px",
                        color: titleColor,
                    }}
                    textStyle={{
                        color: titleColor,
                    }}
                />
            </S.Title>
                <S.ProvidersContainer>
                    {renderImages()}
                    {
                        !hasProviders &&
                        <EmptyMessageContainer>
                            <EmptyMessage
                                message="Select providers & display their logos here"
                                containerStyle={{height: "80px"}}
                            />
                            {renderEditIcon()}
                        </EmptyMessageContainer>
                    }
                    {hasProviders && renderEditIcon()}
                </S.ProvidersContainer>
        </S.Root>
    )
}

export default LeaveReviews;
